module.exports = __webpack_public_path__ + "static/media/feature_list3.8553d38c.png";